export const company = {
  name: 'ÜNYE DÖVİZ',
  shortName: 'ÜNYE',
  legalName: 'ÜNYE DÖVİZ SINIRLI YETKİLİ MÜESSESE ANONİM ŞİRKETİ ( B Sınıfı )',
  classLabel: 'B Sınıfı Yetkili Müessese',
  tagline: 'Güncel kurlar, güvenilir işlem.',
  /** Public asset — Vite base ile uyumlu */
  logo: `${import.meta.env.BASE_URL}logo.png`,
  phone: '0452 324 07 08',
  phoneTel: '+904523240708',
  email: 'info@unyedoviz.com',
  address: 'Kaledere Mah. Akkuş Niksar Cad. No: 50/I Ünye / Ordu',
  taxOffice: 'Ünye',
  taxId: '9190901728',
  activityCode: '661204',
  activityLabel: 'Döviz bürolarının faaliyetleri',
  about:
    'ÜNYE DÖVİZ SINIRLI YETKİLİ MÜESSESE A.Ş., T.C. Hazine ve Maliye Bakanlığı düzenlemeleri ile MASAK (Mali Suçları Araştırma Kurulu) mevzuatı çerçevesinde hizmet veren bir B Sınıfı Yetkili Müessese\'dir.',
  /** Konum: Akkuş Niksar Cad. No: 50/I — Google işletme adına değil koordinata sabit */
  googleMapsUrl:
    'https://www.google.com/maps/search/?api=1&query=Ünye+Döviz+Kaledere+Mah.+Akkuş+Niksar+Cad.+No:+50/I+Ünye+Ordu',
  googleMapsEmbed:
    'https://maps.google.com/maps?q=41.1262887,37.2848153+(Ünye+Döviz)&hl=tr&z=17&ie=UTF8&output=embed',
  boardUrl: '/kiox/',
  workingHours: 'Hafta içi 09:00 – 18:00',
} as const

export type CompanyConfig = typeof company
